import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import router from './router'
import '@babel/polyfill'
import store from './store' // import the store we just created
import VueQuillEditor from 'vue-quill-editor'
import Notifications from 'vue-notification'

import { firestorePlugin } from 'vuefire'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

import TrendChart from "vue-trend-chart"
import ECharts from 'vue-echarts'

import Bars from 'vuebars'

import { getInfo, getTotalRequest } from "@/service/account/login";
import VueCharts from 'vue-chartjs'
import excel from 'vue-excel-export'
import {setMetaTag} from './helper/metaTag'




Vue.config.productionTip = false

Vue.use(VueQuillEditor)
Vue.use(Notifications)
Vue.use(Datetime)
Vue.use(TrendChart)
Vue.use(ECharts)
Vue.use(Bars)
Vue.use(VueCharts)
Vue.use(excel)
Vue.use(firestorePlugin)

router.beforeEach(async (to, from, next) => {
  const publicComponent = ['login', 'select-company', 'enter-password', 'register', 'register-success','forgetpassword'];
  const loginComponent = ['login', 'select-company', 'enter-password'];
  if (publicComponent.findIndex((x) => x === to.name) === -1) {
    // not in public component then check user data
    const token = localStorage.getItem("x-session-token")
    const expToken = localStorage.getItem("expWeb")
    // if(to.name==='login' &&( token!==undefined || expToken > Date.now())){
    //   await this.$router.push({ path: "/" });
    // }
    if (token == undefined || expToken < Date.now()) {
      // localStorage.clear()
      // go login
      
      setMetaTag()
      next({ name: 'login' });
    } else {
      let resultInfo = await getInfo();
      setMetaTag(resultInfo.info.companies[0])
      let resultTotalRequest = await getTotalRequest();
      store.commit("setTheme", resultInfo.info);
      store.commit("setTotal", resultTotalRequest.course);
      if(!resultInfo.info.permission.adminCompany && to.name == "companySetting"){
        next({ name: 'course' });
      } else{
        next();
      }
    }

  } else {
    // go to register
    if (to.query && to.query.token && to.query.token.length > 0) {
      localStorage.clear();
      setMetaTag()
      next();
    } else if (loginComponent.findIndex((x) => x === to.name) === -1) {
      setMetaTag()
      next();
    } else {
      const token = localStorage.getItem("x-session-token")
      const expToken = localStorage.getItem("expWeb")
      if (token == undefined || expToken < Date.now()) {
        setMetaTag()
        next();
      } else {
        let resultInfo = await getInfo();
        store.commit("setTheme", resultInfo.info);
        setMetaTag(resultInfo.info.companies[0])
        next({ name: 'course' });
      }
    }
    // public component
  }






});


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')